import { render, staticRenderFns } from "./statusFallback.vue?vue&type=template&id=93fdce56"
import script from "./statusFallback.vue?vue&type=script&lang=ts"
export * from "./statusFallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports